import { useWindowDimensions } from "react-native";
import { BREAKPOINT_LG, BREAKPOINT_MD, BREAKPOINT_SM, BREAKPOINT_XL } from "../theme/breakpoints";
const useLandingBreakpoint = () => {
    const { width } = useWindowDimensions();
    const isSmUp = width >= BREAKPOINT_SM;
    const isMdUp = width >= BREAKPOINT_MD;
    const isLgUp = width >= BREAKPOINT_LG;
    const isXlUp = width >= BREAKPOINT_XL;
    const current = isXlUp
        ? "XL"
        : isLgUp
            ? "LG"
            : isMdUp
                ? "MD"
                : isSmUp
                    ? "SM"
                    : "XS";
    return { current, isSmUp, isMdUp, isLgUp, isXlUp };
};
export { useLandingBreakpoint };
